import React from 'react';

interface RightArrowWithCircleBackgroundProps {
  size?: number;
}

export const RightArrowWithCircleBackground = ({ size = 25 }: RightArrowWithCircleBackgroundProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12L12 9M12 9L9 6M12 9H6M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#14142B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

